Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-transaction-details-expandable'), model = null;

    if ($wrappers.length < 1) return;

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var wrapper = $wrapper.get(0);
        var transactionCode = $wrapper.data('transaction-code');
        var accountId = $wrapper.data('user-id');
        var initLoading = false;

        var $loadingIndicator = $('.details-loading-indicator', $wrapper);
        var $loadingError = $('.details-loading-error', $wrapper);

        wrapper.loading = function loading(loading, error) {
            if (loading && initLoading) {
                return false;
            }

            initLoading = loading;

            if (loading) {
                $loadingIndicator.show();
                $loadingError.hide();
            } else {
                $loadingIndicator.hide();
                error && $loadingError.show();
            }

            return true;
        };

        wrapper.showLoader = function (loader) {
            var $cont = $wrapper.closest('.x-transaction-box');

            if (loader === true) {
                $cont.addClass('x-loading');
            } else {
                $cont.removeClass('x-loading');
            }
        };

        wrapper.init = function () {
            if (!wrapper.loading(true) || $wrapper.hasClass('already-binded'))
                return;

            wrapper.showLoader(true);
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.TransactionsHistory.Messages.GetAccountDetails(accountId, transactionCode));
        }

        wrapper.update = function () {
            var html = Vendd.Handlebars.parse("accountUserAccountsTransactionBoxDetails_A", model);

            wrapper.bind(html);

            wrapper.loading(false);
            wrapper.showLoader(false);
        };

        wrapper.bind = function bind(html) {
            $wrapper.append(html);
            $wrapper.addClass('already-binded');
        };
    });

    Vendd.MessageBus.subscribe(Vendd.TransactionsHistory.Messages.GetAccountDetailsSuccess, 'x-transaction-details-expandable', function (envelope) {
        model = envelope.message.data;

        var wrapper = envelope.sender;
        if (wrapper) wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.TransactionsHistory.Messages.GetAccountDetailsFailure, 'x-transaction-details-expandable', function (envelope) {
        var wrapper = envelope.sender;
        var response = envelope.message.data;

        if (wrapper) {
            console.log('Failed to load transaction details:', response);

            wrapper.loading(false, true);
            wrapper.showLoader(false);
        }      
    });

});
